import { createFileRoute } from "@tanstack/react-router";
import { legacyReadWriteRoute } from "@/features/legacy-operations";

export const Route = createFileRoute("/api/kits/gmail/watch")({
    ...legacyReadWriteRoute,
});
